export default "__VITE_ASSET__DXBciv8D__"